import request from '@/utils/request'

export default {
    addPv: function (pageId, traderId) {
        return request({
            url: 'pvuv/addPv',
            method: 'post',
            params: {pageId: pageId, traderId: traderId}
        });
    },
}
